module.exports = __webpack_public_path__ + "img/melange_beton.bf222114.jpg";